import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
import { Button } from '../ui/Button';
export function CherrySection() {
  return <section className="bg-black py-[60px] lg:py-[100px] overflow-hidden" data-id="element-1204">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8" data-id="element-1205">
        <div className="flex flex-col-reverse lg:flex-row items-center gap-12 lg:gap-20" data-id="element-1206">
          {/* Left Column - Text */}
          <AnimateOnScroll className="w-full lg:w-[55%]" data-id="element-1207">
            <span className="text-[#FF1493] uppercase text-[13px] font-bold tracking-[2px] mb-4 block font-[Poppins,_sans-serif]" data-id="element-1208">
              FINANCING PARTNER
            </span>

            <h2 className="text-[28px] sm:text-4xl lg:text-[44px] uppercase text-white leading-tight mb-6 font-[600] font-[Poppins,_sans-serif]" data-id="element-1209">
              HOW CHERRY WORKS
            </h2>

            <p className="text-white text-lg font-body leading-[1.7] mb-8" data-id="element-1210">
              We have teamed up with Cherry to offer our patients up to 24
              months financing with 0% APR
            </p>

            <div className="bg-[#111111] border-l-4 border-[#FF1493] p-5 mb-10 rounded-r" data-id="element-1211">
              <p className="text-white text-[15px] italic font-serif" data-id="element-1212">
                "For example, a $500 purchase may cost $20/month for 24 months
                at 0% APR with $25 due at the time of purchase."
              </p>
            </div>

            <div className="space-y-8 mb-10" data-id="element-1213">
              <div data-id="element-1214">
                <h3 className="text-white font-bold text-lg mb-2 font-[Poppins,_sans-serif] flex items-center gap-3" data-id="element-1215">
                  <span className="w-2 h-2 rounded-full bg-[#FF1493]" data-id="element-1216"></span>
                  Apply in Seconds
                </h3>
                <p className="text-[#B0B0B0] text-[15px] font-body leading-relaxed pl-5" data-id="element-1217">
                  Application to approval in seconds. Cherry's completely
                  digital process gets you out the door and enjoying your
                  purchase in no time.
                </p>
              </div>

              <div data-id="element-1218">
                <h3 className="text-white font-bold text-lg mb-2 font-[Poppins,_sans-serif] flex items-center gap-3" data-id="element-1219">
                  <span className="w-2 h-2 rounded-full bg-[#FF1493]" data-id="element-1220"></span>
                  Flexible Payment Options to Fit Any Budget
                </h3>
                <p className="text-[#B0B0B0] text-[15px] font-body leading-relaxed pl-5" data-id="element-1221">
                  Choose from 3, 6, 12, 18, or 24 month payment plans with some
                  qualifying 0% APR options.
                </p>
              </div>

              <div data-id="element-1222">
                <h3 className="text-white font-bold text-lg mb-2 font-[Poppins,_sans-serif] flex items-center gap-3" data-id="element-1223">
                  <span className="w-2 h-2 rounded-full bg-[#FF1493]" data-id="element-1224"></span>
                  No Hard Credit Checks. No Hidden Costs or Fees
                </h3>
                <p className="text-[#B0B0B0] text-[15px] font-body leading-relaxed pl-5" data-id="element-1225">
                  Applying does not impact your credit score! Scan your ID and
                  see how affordable your next purchase can be.
                </p>
              </div>
            </div>

            <p className="text-[#666666] text-xs italic font-body mb-8" data-id="element-1226">
              Payment options through Cherry Technologies, Inc. are issued by
              the following lending partners: withcherry.com/lending-partners.
              0% APR and other promotional rates subject to eligibility.
            </p>

            <Button variant="primary" size="lg" className="w-full sm:w-auto" data-id="element-1227">
              SIGN UP WITH CHERRY
            </Button>
          </AnimateOnScroll>

          {/* Right Column - Image */}
          <AnimateOnScroll className="w-full lg:w-[45%]" delay={200} data-id="element-1228">
            <div className="relative mx-auto max-w-[400px] lg:max-w-none bg-[#111111] rounded-2xl p-12 aspect-square flex items-center justify-center border border-white/5 shadow-[0_0_40px_rgba(255,20,147,0.1)]" data-id="element-1229">
              <div className="absolute inset-0 bg-gradient-to-br from-[#FF1493]/10 to-transparent rounded-2xl" data-id="element-1230"></div>
              <h3 className="text-4xl font-bold text-white relative z-10 font-[Poppins,_sans-serif] tracking-wider" data-id="element-1231">
                CHERRY
              </h3>
            </div>
          </AnimateOnScroll>
        </div>
      </div>
    </section>;
}